import { Autocomplete, Box, CssBaseline, Paper, TextField, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useEffect, useState } from 'react';
import useKeyboardShortcut from 'use-keyboard-shortcut';

// import './styles.css';
// import { GetMaxCode, EncodeLevel3Code, level3CodeType } from './HelperClass';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import swal from 'sweetalert2';
// import Level3CodeDialog from '../atoms/level3CodeDialog';
import { Button, Stack } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
// import { useAppDispatch, useAppSelector } from 'utils/hooks';
import { EncodeLevel3Code, level3CodeType } from '../../../../components/Accounts/Account/HelperClass';
import Level3CodeDialog from '../../../../components/Accounts/Account/level3CodeDialog';
import { updateAllLevels } from '../../../../store/action';
import { GetMaxCode, level3Columns } from '../../../../utils/Level/utils';
import { deleteLevel3, saveLevel3, updateLevel3 } from '../../../../utils/endPoints';
import { useAppDispatch, useAppSelector } from '../../../../utils/hooks';

function LevelThreeChart() {
  const dispatch = useAppDispatch();
  const level_1 = useAppSelector(state => state.accountLevels.level1);
  const level_2 = useAppSelector(state => state.accountLevels.level2);
  const level_3 = useAppSelector(state => state.accountLevels.level3);
  const isMediumOrLargeScreen = useMediaQuery('(min-width: 600px)');
  console.log(level_1, level_2, level_3);
  const [freeze, setFreeze] = useState(false);
  const [showEntryForm, setShowEntryForm] = useState(false);
  const [code, setCode] = useState('');
  const [level1Dcode, setLevel1DCode] = useState('');
  const [level2Dcode, setLevel2DCode] = useState('');
  const [description, setDescription] = useState('');
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState(level3CodeType[0]);
  const [openingBalance, setOpeningBalance] = useState('');
  const [transactionType, setTransactionType] = useState([]);
  const [isUpdateLevel3, setUpdateLevel3] = useState(false);
  const [levelTwoCodes, setLevelTwoCodes] = useState([]);
  const [levelThreeCodes, setLevelThreeCodes] = useState([]);
  const [level1, setLevel1] = useState('');
  const [level2, setLevel2] = useState({
    code: '',
    description: '',
    l1code: '',
    l2code: '',
  });
  const [l2Update, setL2Update] = useState(false);
  const [name, setName] = useState('');
  const [contact, setContact] = useState('');
  const [address, setAddress] = useState('');

  useKeyboardShortcut(['F1'], () => addNewLevelCode(), {
    overrideSystem: true,
  });

  function addNewLevelCode() {
    setUpdateLevel3(false);
    if (level2Dcode == '' || level1Dcode == '') {
    } else {
      setName('');
      setContact('');
      setAddress('');
      setDescription('');
      setOpeningBalance('');
      setTransactionType('');
      setType(level3CodeType[0]);
      setFreeze(false);
      setShowEntryForm(true);
      setCode(EncodeLevel3Code(GetMaxCode(levelThreeCodes)));
    }
  }

  const handleCodeLevel1 = (event, value) => {
    const code = value?.code || '';
    const description = value?.description || '';
    setL2Update(!l2Update);
    setLevelTwoCodes([]);
    setLevelThreeCodes([]);
    if (code !== '') {
      setLevel1({ code, description });
    }
  };

  const handleCodeLevel2 = (event, value) => {
    const code = value?.fullcode || '';
    const description = value?.Description || '';
    const [l1code, l2code] = code.split('-');
    if (code !== '') {
      setLevel2({
        code,
        description,
        l1code,
        l2code,
      });
    } else {
      setLevelThreeCodes([]);
    }
  };

  async function updateLevel3Data(event, params) {
    console.log(params);
    setUpdateLevel3(true);
    setName('');
    setContact('');
    setAddress('');
    setCode(params.row.fullcode.split('-').pop());
    setDescription(params.row.Discription);
    setOpeningBalance(params.row.openingBalance);
    setTransactionType(params.row.transactionType);
    setType(params.row.type);
    if (params.row.name) {
      setName(params.row.name);
      setContact(params.row.contact);
      setAddress(params.row.address);
    }

    let OldValue = freeze;
    if (params.row.freeze == 'NO') {
      setFreeze(false);
    } else {
      setFreeze(true);
    }
    setShowEntryForm(true);
  }
  async function checkCode(data) {
    console.log(data);
    setShowEntryForm(false);

    let codeAlreadyExist = false;
    console.log(levelThreeCodes);
    levelThreeCodes.map(item => {
      if (item.fullcode.split('-')[2] === data.fullcode.split('-')[2]) {
        codeAlreadyExist = true;
      }
    });

    if (codeAlreadyExist === true) {
      swal.fire('Code already in used.').then(async result => {});
    } else {
      let codeArray = data.fullcode.split('-');
      setShowEntryForm(false);
      if (Number(parseInt(codeArray[2], 10)) > Number(0)) {
        if (data.freeze) {
          data.freeze = 'YES';
        } else {
          data.freeze = 'NO';
        }
        let res = await saveLevel3(data.fullcode, data);
        console.log(res);
        toast.success(res?.msg);
        updateAllLevels(dispatch);
      } else {
        toast.error('Invalid  code!');
      }
    }
  }

  function updateLevel3DataQuery(data) {
    console.log(data);
    setShowEntryForm(false);
    swal
      .fire({
        title: 'Are you sure to update existing code?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, update it!',
      })
      .then(async result => {
        setLoading(true);
        if (result.value) {
          if (data.freeze) {
            data.freeze = 'YES';
          } else {
            data.freeze = 'NO';
          }
          const res = await updateLevel3(data.fullcode, data);
          console.log(res);
          if (res?.msg.endsWith('successfully')) {
            toast.success(res.msg);
            updateAllLevels(dispatch);
          } else {
            toast.error('Failed to Update!');
          }
          setLoading(false);
        } else {
          setLoading(false);
        }
      });
    return;
  }
  function deleteLevel3Data(data) {
    console.log(data);
    setShowEntryForm(false);
    swal
      .fire({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, delete it!',
      })
      .then(async result => {
        setLoading(true);
        if (result.value) {
          const res = await deleteLevel3(data.fullcode);
          console.log(res);
          if (res?.msg.endsWith('successfully')) {
            setLoading(false);
            toast.success(res.msg);
            updateAllLevels(dispatch);
          } else {
            setLoading(false);
            swal
              .fire(
                'Failed to delete! Level3 code cannot be deleted if child vouchers exists.',
              )
              .then(async res => {});
            toast.error('Failed to Delete!');
          }
        } else {
          setLoading(false);
        }
      });
  }

  useEffect(() => {
    console.log('i am level2', level1);
    if (level_2) {
      let tempArray = level_2.filter(function (el) {
        return el.fullcode?.startsWith(level1.code);
      });
      console.log(tempArray);
      setLevelTwoCodes(tempArray);

      setLevel1DCode(level1.code);
      setLevel2({
        code: '',
        description: '',
        l1code: '',
        l2code: '',
      });
      setLevel2DCode('');
    }
  }, [level1]);
  // console.log(level1);
  // console.log(levelTwoCodes);
  console.log(level2)
  useEffect(() => {
    setLevel2DCode(level2.code);
    if (level2.code !== '' && level_3) {
      let tempArray = level_3.filter(function (el) {
        return el.fullcode.startsWith(level2.code);
      });
      setLevelThreeCodes(tempArray);
      setCode(EncodeLevel3Code(GetMaxCode(tempArray)));
    }
  }, [level2, level_3]);

  console.log(levelThreeCodes)

  return (
    <Paper>
      <CssBaseline />
      {/* <Loader loading={loading} /> */}

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          // backgroundColor: '#5CDB95',
          justifyContent: 'center',
          marginTop:'1rem',
        }}
      >
        {/* <CompanyAppBar></CompanyAppBar> */}
        <Typography variant="h4" component="h2" gutterBottom>
          Chart of Acc Level '3' List
        </Typography>
        {showEntryForm ? (
          <Level3CodeDialog
            okCallback={data => {
              checkCode(data);
            }}
            cancelCallback={() => {
              setShowEntryForm(false);
            }}
            updateCallback={data => {
              updateLevel3DataQuery(data);
            }}
            deleteCallback={data => {
              deleteLevel3Data(data);
            }}
            l1code={level1Dcode}
            l2code={level2Dcode}
            newCode={code}
            defaultDescription={description}
            types={level3CodeType}
            openingBalance={openingBalance}
            defaultName={name}
            defaultAddress={address}
            defaultContact={contact}
            defaultFreeze={freeze}
            visible={showEntryForm}
            defaultType={type}
            defaultOpeningBalance={openingBalance}
            defaultTransactionType={transactionType}
            updateLevel3={isUpdateLevel3}
          ></Level3CodeDialog>
        ) : (
          <></>
        )}
        <Stack direction={isMediumOrLargeScreen ? 'row' : 'column'} spacing={2}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              // width: width,
              // marginTop: marginTop,
            }}
          >
            <Box sx={{ minWidth: '90%' }}>
              <Autocomplete
                // onBlurCapture={handleCodeLevel1}
                onChange={handleCodeLevel1}
                disablePortal
                id="combo-box-code"
                getOptionLabel={option =>
                  option.code + '\t' + option.Discription
                }
                options={level_1}
                renderInput={params => (
                  <TextField
                    {...params}
                    style={{ width: '300px' }}
                    label="Level One Code"
                  />
                )}
              />
            </Box>
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              // width: width,
              // marginTop: marginTop,
            }}
          >
            <Box sx={{ minWidth: '90%' }}>
              <Autocomplete
                key={l2Update}
                // onBlurCapture={handleCodeLevel2}
                onChange={handleCodeLevel2}
                disablePortal
                id="combo-box-code"
                getOptionLabel={option =>
                  option.fullcode + '\t' + option.Discription
                }
                options={levelTwoCodes}
                renderInput={params => (
                  <TextField
                    {...params}
                    style={{ width: '300px' }}
                    label="Level Two Code"
                  />
                )}
              />
            </Box>
          </div>
          <Button variant="contained" onClick={addNewLevelCode}>
            Add
          </Button>
        </Stack>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: '90%',
            height: '75vh',
            // backgroundColor: '#EDF5E1',
            marginTop: '1rem',
          }}
        >
          <DataGrid
            hideFooter
            headerHeight={20}
            rowHeight={25}
            onCellDoubleClick={(params, event) => {
              updateLevel3Data(event, params);
            }}
            style={{ width: '100%' }}
            // onCellClick={CellonClick}
            rows={levelThreeCodes.map((item, index) => {
              return { id: index + 1, ...item };
            })}
            columns={level3Columns}
            pageSize={25}
            disableColumnMenu
          />
        </div>
      </div>
      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={true}
        closeOnClick={true}
        progress={undefined}
      />
    </Paper>
  );
}

export default LevelThreeChart;
